{
    "form-editor": {
        "nav": {
            "undo": "Rückgängig machen ({{Hotkey}})",
            "redo": "Wiederherstellen ({{Hotkey}})",
            "embed": "Einbetten ({{Hotkey}})",
            "open-in-browser": "Formular im Browser öffnen",
            "formVersionHistory": "Versionsverlauf anzeigen",
            "unpublishForm": "Privatisieren",
            "publishForm": "Veröffentlichen",
            "saveForm": "Speichern",
            "saveFormAs": "Speichern als…",
            "exportForm": "Export…",
            "importFormFile": "Import…",
            "renameForm": "Umbenennen…",
            "deleteForm": "Löschen…",
            "exportL10n": "Lokalisierung exportieren...",
            "importL10n": "Lokalisierung importieren..."
        },
        "layout": {
            "title": "Layout",
            "description": "Ziehen Sie Formularelemente per Drag-and-Drop, um Ihre gewünschte Struktur zu erstellen",
            "edit": {
                "title": "Bearbeiten",
                "outline": "Umriss",
                "components": "Komponenten",
                "settings": "Einstellungen"
            },
            "translate": {
                "title": "Übersetzen",
                "outline": "Umriss",
                "components": "Komponenten",
                "settings": "Einstellungen"
            },
            "preview": {
                "title": "Vorschau",
                "outline": "Umriss",
                "scope": "Zielfernrohr",
                "settings": "Einstellungen"
            }
        },
        "datasources": {
            "title": "Datenquellen",
            "description": "Konfigurieren Sie statische Daten, die in Ihrem Formular benötigt werden.",
            "confirmDeleteCascade": "Von dieser Löschung werden Elemente beeinträchtigt, fortfahren?"
        },
        "workflow": {
            "title": "Arbeitsablauf",
            "description": "Steuern Sie das Verhalten Ihres Formulars.",
            "flow": "Fluss",
            "settings": "Einstellungen",
            "library": "Bücherei",
            "formReadyNode": "Am Start",
            "formSubmitNode": "Auf Senden",
            "nothingSelected": "Nichts ausgewählt"
        },
        "constants": {
            "title": "Konstanten",
            "description": "Konfigurieren Sie konstante Werte, die überall in Ihrem Formular verwendet werden sollen."
        },
        "saveFormAsDialog": {
            "title": "Speichern als",
            "successToast": "Gerettet",
            "namePlaceholder": "Name"
        },
        "renameFormDialog": {
            "title": "Umbenennen",
            "namePlaceholder": "Name"
        },
        "deleteFormDialog": {
            "message": "Möchten Sie {{name}} endgültig löschen?",
            "busyToast": "{{Name}} wird gelöscht…",
            "doneToast": "Gelöscht {{name}}…"
        },
        "formVersionHistoryDialog": {
            "title": "Versionsgeschichte"
        },
        "formVersionHistory": {
            "revert": "Kehren Sie zu dieser Version zurück",
            "duplicate": "Neues Projekt aus dieser Version erstellen"
        },
        "formEmbedDialog": {
            "title": "Einbetten"
        },
        "hyperlinkEmbed": {
            "title": "Hyperlinks",
            "description": "Einfach auf das gehostete Formular verlinken."
        },
        "inlineEmbed": {
            "title": "Inline-Tag",
            "description": "Betten Sie ein Formular mit einem bereitgestellten benutzerdefinierten Tag in ein HTML-Dokument ein."
        },
        "previewSettings": {
            "authGroupTitle": "Authorisierung",
            "customLocals": "Vorschau Umgebungsvariablen",
            "customLocalsVariable": "Variablenname",
            "customLocalsValue": "Wert"
        },
        "confirmMergeDialog": {
            "message": "Eine neuere Version des Formulars ist vorhanden, wollen Sie die folgenden Änderungen übernehmen?"
        }
    },
    "mask": {
        "BuilderFormMask": {
            "name": "Name (intern)",
            "published": "Veröffentlicht",
            "behaviourGroupTitle": "Verhalten",
            "showValidFeedback": "Gültiges Feld Feedback anzeigen",
            "customizationGroupTitle": "Anpassung",
            "includeCoreResources": "Kernressourcen einbeziehen",
            "includeBootstrapCdn": "Bootstrap-CDN einschließen",
            "bootstrapCdnUrl": "Bootstrap-CDN-Ressource",
            "resources": "Zusätzliche Ressourcen",
            "resourcesUrl": "URL",
            "stylesheet": "Inline-Stylesheet"
        },
        "BuilderInlineEmbedMask": {
            "description": "### Inline Embed\nBetten Sie ein Formular mit einem bereitgestellten benutzerdefinierten Tag in ein HTML-Dokument ein.\nSie können Variablen an das Formular übergeben, indem Sie ein `data-session=\"{YOUR_JSON_OBJECT_LITERAL}\"-Attribut hinzufügen oder Ihr Json-Objekt-Literal in den Körper des Skript-Tags einfügen.\n\rSollten Sie sich von einem Dokument aus authentifizieren wollen, in dem die `dodo`-Bibliothek verfügbar ist, können Sie das `data-identity-provider=\"dodo\"-Attribut hinzufügen.\n\rWenn Sie die Suchparameter des Host-Dokuments im Formular als Variablen zur Verfügung stellen möchten, fügen Sie bitte das Attribut `data-use-host-search-params` zum Script-Tag hinzu.\n\r",
            "code": "Embed Code"
        }
    },
    "elementControls": {
        "deleteElement": "Dieses Element löschen",
        "copyElement": "Dieses Element kopieren",
        "cutElement": "Dieses Element ausschneiden",
        "pasteElement": "Nach diesem Element einfügen",
        "savePreset": "Vorlage mit diesem Element erstellen oder aktualisieren"
    },
    "import-l10n": {
        "importing": "Importiere...",
        "success": {
            "singular": "Import erfolgreich. Ein Lokalisierungsschlüssel wurde aktualisiert.",
            "plural": "Import erfolgreich. {{count}} Lokalisierungsschlüssel wurden aktualisiert."
        },
        "unmatchedElementsMessage": {
            "singular": "Ein Element wurde ignoriert.",
            "plural": "{{count}} Elemente wurden ignoriert."
        }
    }
}